import React, { Component } from 'react';
import { Route, Redirect, Link} from 'react-router-dom';
import SearchResults from './searchResults.js';
import AddDPP from './asdf.js';


class SearchWSDE extends Component {
  constructor() {
    super();
    this.winHeight = window.innerHeight;
    this.winWidth = window.innerWidth;
    this.mapKeys = {};
    this.active = false;
    this.currentSearch="";
    this.currentPlaceHolder= "Search"
    this.state = {
      redirect: false,
      zipSearch: false,
      addDPP:false,
      data:[]
    }
  };

  componentDidMount() {
    this.checkURL();
    window.addEventListener('keydown', this.screenCheck, false);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.screenCheck, false);
  }

  screenCheck = (e) => {
    this.mapKeys[e.key] = e.type === 'keydown';
    if(this.active && e.key==="Escape"){
      var term1 = document.querySelector('input[name=search]');
      term1.value = "";
      this.closeSearch();
    }
    else if(this.active === false && e.key !== "Escape" ){
      this.fullSearch();
    }
  }

  fullSearch = () => {
    this.active = true;
    document.getElementById("searchBar").focus();
    document.getElementById("searchField").classList.add("fullRed");
    if(!document.getElementById("searchBar").value){
      this.currentPlaceHolder = document.getElementById("searchBar").placeholder;
      document.getElementById("searchBar").placeholder= "search"
    }
  }

  closeSearch = (search) => {
    var section = (window.location.href).split('/')[3];
    this.active=false;
    this.setState({addDPP: false});
    document.getElementById("searchBar").blur();
    document.getElementById("searchField").classList.remove("fullRed");
    document.getElementById("searchField").classList.remove("searchFullHeight");
    // document.getElementById("searchTags").classList.remove("displayActive");
    if(!section )
    {
      this.currentPlaceHolder = "Search";
    }
    else if(!document.getElementById("searchBar").value && !search ){
      document.getElementById("searchBar").placeholder= this.currentPlaceHolder;
      // Transfer from placeholder to saved search content?
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    var search = document.getElementById("searchBar").value;
    var checkZip = Number.isInteger(Number(search.trim())) && search.trim().length === 5 && search.trim();

    // if search is a zip,
    if (checkZip) {
      this.currentSearch = Number(checkZip);
      this.setState({zipSearch:true});

      // fetch lat/lng from google api
      const mapsAPIUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + checkZip + '&key=AIzaSyBtakkCW71JErx-dvCmc3WVNw24XQ2BMQY';
      fetch(mapsAPIUrl)
      .then( response => {
        return response.json();
      })
      .then( myJson => {
        const {lat, lng} = myJson.results[0].geometry.location;
        this.goToPlace(lat, lng, null);
      });
    } else {
      this.currentSearch = search.split(' ').join('+');
      this.setState({
        zipSearch:false,
        redirect:true
      });
    }
    document.getElementById("searchBar").placeholder = search
    var term1 = document.querySelector('input[name=search]');
    term1.value = "";
    // this.closeSearch();
  }

  checkURL = () => {
    document.getElementById("searchBar").value = ""
    var url = new URL(window.location.href);
    const path = window.location.href;
    var currentID = path.split('/')[4];
    if(currentID === "submit"){
      this.runForm();
    }
    const search = url.searchParams.get("term") || url.searchParams.get("zipSearch");
    // var url2 = window.location.href
    // var section = url2.split('/')[3].split('?')[0];
    // section = section.toLowerCase();

    if(search){
      document.getElementById("searchBar").placeholder = search
      this.currentSearch = search
      this.setState({redirect:true})
    }
    // else if(section || section === "Search"){
    //   document.getElementById("searchBar").placeholder = "Search"
    // }
    else{
      document.getElementById("searchBar").placeholder = "Search"
    }

    // search ? document.getElementById("searchBar").placeholder = search
    // : (section || section === "Search") ? document.getElementById("searchBar").placeholder = "Search"
    // : document.getElementById("searchBar").placeholder = "Search"
  }
  runForm=()=>{
    this.setState({addDPP:true},()=>{
      this.fullSearch();
    })
  }

  goToPlace=(lat,lng, marker)=>{
    this.closeSearch();
    this.props.moveMap(lat, lng, marker);
  }

  toggleForm = () => {
    const formActive = this.state.addDPP;
    this.setState({addDPP: !formActive});
  }

  render() {
    return (
      <div id="appContain" className="fullWidth fullHeight">
        {this.state.addDPP ? (
          <AddDPP toggleForm={this.toggleForm}/>
        ):('')}
        {this.state.redirect ? (
          <React.Fragment>
            <Redirect push to={"/dual-power-map/search?term="+this.currentSearch} />
          </React.Fragment>
        ):('')}
        {this.state.zipSearch ? (
          <React.Fragment>
            <Redirect push to={"/dual-power-map/zipSearch?zip="+this.currentSearch} />
          </React.Fragment>
        ):('')}
        <div id="searchField" className="relative searchBar pbMed " >
          <Route path="/dual-power-map/search" render={()=><SearchResults redirect={this.state.redirect} moveMap={this.goToPlace} addPlace={this.toggleForm}/>}/>
          <form id="searchHold"  className="fullWidth" action="/dual-power-map/search?:id" method="GET" name="search" onSubmit={this.handleSubmit}>
            <input onClick={this.fullSearch.bind(this)} id="searchBar" autoComplete="off" className="searchField center" name="search" type="text" placeholder="Search"></input>
          </form>
          <div className="redField fullWidth fullHeight">
            {!this.state.redirect  ? (
              <h3 className="tfStage centeredContent blkT centerT upperT">Search by keyword</h3>
            ):('')}
          </div>
          <Link onClick={this.closeSearch} to="/dual-power-map/search"><div  className="closeSearch marginBotSmall">×</div></Link>
        </div>
      </div>
    );
  }
}

export default SearchWSDE;



// WEBPACK FOOTER //
// ./src/components/strategy/wsde/searchAlt.js